import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useNow } from '../../api/resources/useNow';
import { formatTime, getTimeDifference } from '../../utils';
import { ActivityTimeDiffDisplay } from './ActivityTimeDiffDisplay';

interface ActivityTileLayoutProps {
  captureStartAt: string;
  licensePlate: string;
  isFocus: boolean;
  children: ReactNode;
}

export function ActivityTileLayout({ captureStartAt, licensePlate, isFocus, children }: ActivityTileLayoutProps) {
  const now = useNow();
  const formattedTime = formatTime(new Date(captureStartAt));
  const activityTimeDiff = getTimeDifference(new Date(captureStartAt), now);

  return (
    <Box
      sx={{
        width: '100%',
        height: '50em',
        borderRadius: '10px',
        border: isFocus ? '1px solid rgba(89, 109, 246, 1)' : '1px solid transparent',
        boxShadow: isFocus ? '0 0 9px 0 rgba(89, 109, 246, 0.4)' : 'none',
        transition: 'all 0.4s ease-in-out',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        backgroundColor: '#fff',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          backgroundColor: '#f8fafc',
          padding: '0.5em 1em',
          alignItems: 'center',
          gap: '1em',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '0.5em' }}>
          <Typography variant='h6'>{formattedTime}</Typography>
          <Typography variant='body2'>–</Typography>
          <Typography variant='body2'>
            <ActivityTimeDiffDisplay timeDiff={activityTimeDiff} />
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5em',
            border: 1,
            p: 1,
            borderRadius: 2,
            borderColor: 'divider',
            minWidth: '8em',
            backgroundColor: '#fff',
          }}
        >
          <LocalShippingIcon sx={{ width: '0.9em', height: '0.9em' }} />
          <Typography variant='h6'>{licensePlate}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          padding: '1em',
          gap: '1em',
          minHeight: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
